export default __webpack_public_path__ + "static/media/logo-estoque.ec2a8077.svg";